import React from "react";

export default function () {
    return <div><span>Loading...</span></div>;
}
